export const createFormDataPayloadWithFile = ({ data, file }) => {
  const payload = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        payload.append(`${key}[]`, item);
      });
      return;
    }

    if (typeof value === 'object' && !(value instanceof Blob) && !(value instanceof File)) {
      payload.append(key, JSON.stringify(value));
      return;
    }

    payload.append(key, value);
  });

  if (file) {
    payload.append('file', file);
  }

  return payload;
};
